import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileFilter'
})
export class FileFilterPipe implements PipeTransform {
    transform(value: any|any[], attachmentTypeID: number) {
        if (value ==  null) { return null; }

        if (!Array.isArray(value)) {
            return (value.AttachmentTypeID === attachmentTypeID ? value : null);
        }

        return <any[]>value.find(v => v.AttachmentTypeID === attachmentTypeID);
    }
}
